<template>
    <div id="">
        <div class="inputList">
            <div class="company">Key Market & Customers</div>
            <div class="flex-center">
                <div class="text-bold text-underline flex-end text-center1">
                    <div style="margin-right: 10px">% of turnover</div>
                    <div>Exclusivity?</div>
                </div>
                <div class="text-bold text-underline flex-end text-center1">
                    <div style="margin-right: 10px">% of turnover</div>
                    <div>Exclusivity?</div>
                </div>
            </div>

            <div
                class="flex-start"
                style="flex-wrap: wrap; cursor: not-allowed"
                v-if="type == 'Echo'"
            >
                <div
                    class="checkboxs chek1"
                    v-for="(item, index) in dataList"
                    :key="index"
                >
                    <div class="parent flex-between">
                        <el-checkbox
                            disabled
                            :indeterminate="item.isIndeterminate"
                            v-model="item.checked"
                        >
                            {{ item.dictName }}
                        </el-checkbox>
                        <div
                            class="flex-between trans w-14"
                            v-if="item.checked"
                        >
                            <div class="tag flex-center">
                                <div>
                                    <input
                                        type="number"
                                        disabled
                                        v-model="item.turnover"
                                    />
                                </div>
                                <div class="text-normal">%</div>
                            </div>
                            <el-checkbox
                                class="mr-5"
                                :label="index + 1"
                                disabled
                                v-model="item.exclusivity"
                            >
                            </el-checkbox>
                        </div>
                    </div>
                    <div class="children">
                        <div
                            class="checkboxList flex-between"
                            v-for="(items, s) in item.childArray"
                            :key="s"
                        >
                            <el-checkbox
                                style="width: 210px"
                                disabled
                                v-model="items.checked"
                                :label="items.dictName"
                            >
                            </el-checkbox>

                            <div
                                class="flex-between trans w-14"
                                v-if="items.checked"
                            >
                                <div class="tag flex-center">
                                    <div>
                                        <input
                                            type="number"
                                            disabled
                                            v-model="items.turnover"
                                        />
                                    </div>
                                    <div class="text-normal">%</div>
                                </div>
                                <el-checkbox
                                    class="mr-5"
                                    :label="s + 1"
                                    disabled
                                    v-model="items.exclusivity"
                                >
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-start" style="flex-wrap: wrap" v-else>
                <div
                    class="checkboxs chek1"
                    v-for="(item, index) in dataList"
                    :key="index"
                >
                    <div class="parent flex-between">
                        <el-checkbox
                            :indeterminate="item.isIndeterminate"
                            v-model="item.checked"
                            :disabled="disabled"
                            @change="handleCheckAllChange(index, $event)"
                        >
                            {{ item.dictName }}
                        </el-checkbox>
                        <div
                            class="flex-between trans w-14"
                            v-if="item.checked"
                        >
                            <div class="tag flex-center">
                                <div>
                                    <input
                                        type="number"
                                        v-model="item.turnover"
                                        :disabled="disabled"
                                        @change="filterList"
                                    />
                                </div>
                                <div class="text-normal">%</div>
                            </div>
                            <el-checkbox
                                class="mr-5"
                                :label="index + 1"
                                v-model="item.exclusivity"
                                :disabled="disabled"
                                @change="filterList"
                            >
                            </el-checkbox>
                        </div>
                    </div>
                    <div class="children">
                        <div
                            class="checkboxList flex-between"
                            v-for="(items, s) in item.childArray"
                            :key="s"
                        >
                            <el-checkbox
                                style="width: 210px"
                                v-model="items.checked"
                                :label="items.dictName"
                                :disabled="disabled"
                                @change="
                                    handleCheckedCitiesChange(
                                        index,
                                        items.id,
                                        $event
                                    )
                                "
                            >
                            </el-checkbox>

                            <div
                                class="flex-between trans w-14"
                                v-if="items.checked"
                            >
                                <div class="tag flex-center">
                                    <div>
                                        <input
                                            type="number"
                                            v-model="items.turnover"
                                            :disabled="disabled"
                                            @change="filterList"
                                        />
                                    </div>
                                    <div class="text-normal">%</div>
                                </div>
                                <el-checkbox
                                    class="mr-5"
                                    :label="s + 1"
                                    v-model="items.exclusivity"
                                    :disabled="disabled"
                                    @change="filterList"
                                >
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Scope",
    props: {
        type: {
            type: String,
            default: "",
        },
        list: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataList: [],
        };
    },
    created() {
        let productList = JSON.parse(
            localStorage.getItem("key_market_customers")
        );
        // if (this.type == "Echo") {
        //   this.dataList = this.formatEcho(productList);
        // } else {
        //   this.dataList = this.format(productList);
        // }
        if (productList) {
            this.dataList = this.formatEcho(productList);
        } else {
            this.dataList = this.format(productList);
        }
    },
    methods: {
        // 全选反选的多选框
        handleCheckAllChange(index, e) {
            this.dataList[index].checked = e;
            if (e == false) this.dataList[index].isIndeterminate = false;
            var childrenArray = this.dataList[index].childArray;
            if (childrenArray) {
                for (var i = 0, len = childrenArray.length; i < len; i++)
                    childrenArray[i].checked = e;
            }

            this.filterList();
        },

        handleCheckedCitiesChange(index, sobId, e) {
            var childrenArray = this.dataList[index].childArray;
            var tickCount = 0,
                unTickCount = 0,
                len = childrenArray.length;
            for (var i = 0; i < len; i++) {
                if (sobId == childrenArray[i].sobId)
                    childrenArray[i].checked = e;
                if (childrenArray[i].checked == true) tickCount++;
                if (childrenArray[i].checked == false) unTickCount++;
            }
            if (tickCount == len) {
                this.dataList[index].checked = true;
                this.dataList[index].isIndeterminate = false;
            } else if (unTickCount == len) {
                this.dataList[index].checked = false;
                this.dataList[index].isIndeterminate = false;
            } else {
                this.dataList[index].checked = false;
                this.dataList[index].isIndeterminate = true;
            }

            this.filterList();
        },

        filterList() {
            let list = [];
            this.dataList.forEach((vs) => {
                if (vs.checked) {
                    list.push({
                        dictId: vs.id,
                        dictName: vs.dictName,
                        trunover: vs.turnover,
                        exclusivity: vs.exclusivity,
                    });
                }
                vs.childArray.forEach((ks) => {
                    if (ks.checked) {
                        list.push({
                            dictId: ks.id,
                            dictName: ks.dictName,
                            trunover: ks.turnover,
                            exclusivity: ks.exclusivity,
                        });
                    }
                });
            });
            this.$emit("change", list);
        },

        // 给返回的数据加是否选中的属性
        format(items) {
            return items.map((item) => {
                const result = {
                    ...item,
                    turnover: null,
                    exclusivity: false,
                    checked: false,
                    isIndeterminate: false,
                };
                if (item.childArray) {
                    result.childArray = this.format(item.childArray);
                }
                return result;
            });
        },

        // 回显
        formatEcho(productList) {
            productList.forEach((s) => {
                s.turnover = "";
                s.checked = false;
                s.exclusivity = false;
                s.isIndeterminate = false;
                this.list.forEach((d) => {
                    let exclusivity = d.exclusivity
                        ? eval(d.exclusivity.toLowerCase())
                        : false;
                    if (s.id == d.dictId) {
                        s.checked = true;
                        s.turnover = d.trunover;
                        s.exclusivity = exclusivity;
                    }
                });
                let list = 0;
                s.childArray.forEach((k) => {
                    k.turnover = "";
                    k.checked = false;
                    k.exclusivity = false;
                    k.isIndeterminate = false;
                    this.list.forEach((f) => {
                        let exclusivity = f.exclusivity
                            ? eval(f.exclusivity.toLowerCase())
                            : false;
                        if (k.id == f.dictId) {
                            k.checked = true;
                            k.turnover = f.trunover;
                            k.exclusivity = exclusivity;
                            list++;
                        }
                    });
                });
                if (s.childArray.length > list) {
                    s.isIndeterminate = true;
                }
            });
            return productList;
        },
    },
};
</script>

<style></style>
